import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PortalPrivateRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated } = useSelector((state) => state.portalAuth);

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/customer-complaint/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
};

export default PortalPrivateRoute;
